import {
  SKILL_BUFF_DURATION_MS_PER_CARD,
  SKILL_DEFAULT_BUFF_DURATION_MS,
} from "@/character/skills/constants";
import type { SkillDefinition } from "@/character/skills/types";
import type { HomeEconomy } from "@/home/economy";

export function skillBuffDurationCardsApplied(skill: SkillDefinition): number {
  const n = skill.buffDurationCards ?? 0;
  return Math.max(0, Math.floor(n));
}

export function skillEffectiveBuffDurationMs(skill: SkillDefinition): number {
  const extra = skillBuffDurationCardsApplied(skill) * SKILL_BUFF_DURATION_MS_PER_CARD;
  return SKILL_DEFAULT_BUFF_DURATION_MS + extra;
}

export function formatBuffDurationSeconds(ms: number): string {
  const sec = ms / 1000;
  if (Math.abs(sec - Math.round(sec)) < 1e-6) {
    return String(Math.round(sec));
  }
  return sec.toFixed(1);
}

export type UpgradeSkillBuffDurationCardResult =
  | { ok: true; economy: HomeEconomy; skill: SkillDefinition }
  | { ok: false; reason: string };

export function upgradeSkillWithBuffDurationCard(
  economy: HomeEconomy,
  skill: SkillDefinition,
): UpgradeSkillBuffDurationCardResult {
  if (skill.kind !== "buff") {
    return { ok: false, reason: "ใช้ได้กับสกิลบัฟเท่านั้น" };
  }
  if (economy.skillBuffDurationCards < 1) {
    return { ok: false, reason: "ไม่มีบัตรเวลาบัฟในคลัง · ซื้อที่ร้าน Cash" };
  }
  const applied = skillBuffDurationCardsApplied(skill);
  return {
    ok: true,
    economy: {
      ...economy,
      skillBuffDurationCards: economy.skillBuffDurationCards - 1,
    },
    skill: {
      ...skill,
      durationMs: SKILL_DEFAULT_BUFF_DURATION_MS,
      buffDurationCards: applied + 1,
    },
  };
}
